import { notification } from "antd";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { extractSignXml } from "@shared/ui";
import { usePostSignEntry } from "../mutate-hooks/use-post-sign-entry";

export const useWithSignedString = () => {
  const { mutateAsync: sendSignedXml } = usePostSignEntry();

  const withSignedString = async (
    params: {
      sectionOneListId?: string;
      sectionListId?: string;
      itemNoVersionId: string;
      signerEmployeeId: string;
      onSuccess?: () => void;
    },
    signedXml: string,
    mchdId?: string,
  ) => {
    try {
      const signXml = extractSignXml(signedXml);

      await sendSignedXml({
        params: {
          path: {
            sectionOneListId: params.sectionOneListId || params.sectionListId || "",
            itemNoVersionId: params.itemNoVersionId,
          },
        },
        body: {
          signer: {
            signerEmployeeId: params.signerEmployeeId,
          },
          signXml,
          ...(mchdId ? { mchdId } : {}),
        },
      });

      params.onSuccess?.();
    } catch (err: any) {
      notification.error({
        message: NOTIFICATION_MESSAGES.XML_SIGN_SEND_ERROR, // "Ошибка отправки подписи"
        description: err.response?.data?.errorDescription || "Неизвестно",
        placement: "topRight",
      });
    }
  };

  return {
    withSignedString,
  };
};

